import { MouseEvent, RefObject, useCallback, useState } from "react";

const useHeaderMenuActive = (
  parentRef: RefObject<HTMLAnchorElement | HTMLDivElement>
): {
  active: boolean;
  handleMouseEnter: () => void;
  handleMouseLeave: (event: MouseEvent) => void;
  handleMouseLeaveMenu: (event: MouseEvent) => void;
} => {
  const [active, setActive] = useState<boolean>(false);

  const handleMouseEnter = useCallback(() => {
    setActive(true);
  }, [setActive]);

  const handleMouseLeave = useCallback(
    (event: MouseEvent) => {
      if (parentRef.current) {
        const { top, height } = parentRef.current.getBoundingClientRect();
        if (top + height <= event.clientY) {
          return;
        } else {
          setActive(false);
        }
      }
    },
    [parentRef, setActive]
  );

  const handleMouseLeaveMenu = useCallback(
    (event: MouseEvent) => {
      if (parentRef.current) {
        const { left, right, top, height } = parentRef.current.getBoundingClientRect();
        if (left < event.clientX && event.clientX < right && top + height > event.clientY) {
          return;
        } else {
          setActive(false);
        }
      }
    },
    [parentRef, setActive]
  );

  return { active, handleMouseEnter, handleMouseLeave, handleMouseLeaveMenu };
};

export default useHeaderMenuActive;
